/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInterestRate} from '../api'

 export const useQueryGetInterestRate = createReactQueryHook('getInterestRate', getInterestRate)
